import Vue from 'vue'
import urls from '../services.url.js'
import authHeaders from './headers'

export default {
  getAllNews () {
    var target = urls.BLOG_POST_URL + '?type=0'
    return Vue.http.get(target)
  },
  getPaginatedNews (pageId) {
    var target = urls.BLOG_POST_URL + '?type=0&page=' + pageId
    return Vue.http.get(target)
  },
  likeNews (userId, postId) {
    let body = '{"user":' + userId + ',"post":' + postId + '}'
    var target = urls.LIKE_URL
    return Vue.http.post(target, body, {'headers': authHeaders.getAuthHeaders()})
  },
  disLikeNews (userId, postId) {
    var target = urls.DISLIKE_URL + '?post_id=' + postId + '&user_id=' + userId
    console.log(target)
    return Vue.http.delete(target, {'headers': authHeaders.getAuthHeaders()})
  },
  isLiked (userId, postId) {
    let url = urls.LIKE_URL + '?post_id=' + postId + '&user_id=' + userId
    return Vue.http.get(url)
  },
  getDetailedNews (id) {
    var target = urls.BLOG_POST_URL + id + '/'
    return Vue.http.get(target)
  },
  createNews (article) {
    let body = JSON.stringify(article)
    return Vue.http.post(urls.BLOG_POST_URL, body, {'headers': authHeaders.getAuthHeaders()})
  },
  updateNews (article) {
    let body = JSON.stringify(article)
    let url = urls.BLOG_POST_URL + article.id + '/'
    return Vue.http.put(url, body, {'headers': authHeaders.getAuthHeaders()})
  },
  deleteNews (article) {
    let url = urls.BLOG_POST_URL + article.id + '/'
    return Vue.http.delete(url, {'headers': authHeaders.getAuthHeaders()})
  }
}



// WEBPACK FOOTER //
// ./src/api/real-api/news.api.js